import FingerprintJS from '@fingerprintjs/fingerprintjs';
import type { Agent } from '@fingerprintjs/fingerprintjs';

let loadedFp = null as Agent | null;

export const useFingerprint = async () => {
	if (loadedFp === null) {
		loadedFp = await FingerprintJS.load();
	}

	const getFingerprint = async () => {
		if (loadedFp !== null) {
			const { visitorId } = await loadedFp.get();

			return visitorId;
		}
		return null;
	};

	return {
		get: getFingerprint,
	};
};
